import { IconInfoCircle } from '@tabler/icons-react';
import PropTypes from 'prop-types';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { notifications } from '@mantine/notifications';
import NotificationsContext from './NotificationsContext';
import classes from './NotificationsProvider.module.css';

export default function NotificationsProvider({ children }) {
  const { t } = useTranslation();
  const setNotifications = useCallback(
    (item) => {
      if (Array.isArray(item)) {
        item.forEach((notification) =>
          notifications.show({
            title: t('keywords.info'),
            message: notification,
            classNames: classes,
            icon: <IconInfoCircle />,
          }),
        );
      } else {
        notifications.show({
          title: t('keywords.info'),
          message: item,
          classNames: classes,
          icon: <IconInfoCircle />,
        });
      }
    },
    [t],
  );
  const setErrors = useCallback(
    (error) => {
      if (Array.isArray(error)) {
        error.forEach((notification, index) =>
          setTimeout(() => {
            notifications.show({
              title: t('keywords.error'),
              message: notification,
              classNames: classes,
              color: 'red',
              icon: <IconInfoCircle />,
            });
          }, 200 * index),
        );
      } else {
        notifications.show({
          title: t('keywords.error'),
          message: error,
          color: 'red',
          icon: <IconInfoCircle />,
          classNames: classes,
        });
      }
    },
    [t],
  );

  const notificationsContext = useMemo(
    () => ({
      notifications,
      setErrors,
      setNotifications,
    }),
    [setNotifications, setErrors],
  );

  return (
    <NotificationsContext.Provider value={notificationsContext}>
      {children}
    </NotificationsContext.Provider>
  );
}

NotificationsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
